module.exports = __webpack_public_path__ + "img/zhkt.d1a75408.jpg";